export const fast_track_phases = [
  'Just curious',
  'Actively researching',
  'Ready to purchase',
];
